import React from 'react';
import { TrendingUp, Users, Music } from 'lucide-react';

export function DiscoverPanel() {
  return (
    <div className="w-80 border-l border-divider overflow-y-auto">
      <div className="p-4">
        <h2 className="text-lg font-bold mb-4">Entdecken</h2>

        <div className="mb-6">
          <div className="flex items-center gap-2 mb-3">
            <TrendingUp size={18} />
            <h3 className="font-medium">Trending</h3>
          </div>
          {['#ProducerChallenge', '#NeueMusik', '#BeatBattle'].map((tag) => (
            <div key={tag} className="py-2">
              <p className="font-medium hover:text-accent-primary cursor-pointer">
                {tag}
              </p>
              <p className="text-sm text-text-tertiary">1,2k Beiträge</p>
            </div>
          ))}
        </div>

        <div className="mb-6">
          <div className="flex items-center gap-2 mb-3">
            <Users size={18} />
            <h3 className="font-medium">Vorgeschlagene Künstler</h3>
          </div>
          {[
            {
              name: 'Alex Turner',
              image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e',
              genre: 'Elektronisch'
            },
            {
              name: 'Emma Lee',
              image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330',
              genre: 'Pop'
            }
          ].map((artist) => (
            <div key={artist.name} className="flex items-center gap-3 py-2">
              <img
                src={artist.image}
                alt={artist.name}
                className="w-10 h-10 rounded-full"
              />
              <div>
                <p className="font-medium">{artist.name}</p>
                <p className="text-sm text-text-tertiary">{artist.genre}</p>
              </div>
              <button className="ml-auto px-3 py-1 bg-accent-primary hover:bg-accent-hover rounded-full text-sm">
                Folgen
              </button>
            </div>
          ))}
        </div>

        <div>
          <div className="flex items-center gap-2 mb-3">
            <Music size={18} />
            <h3 className="font-medium">Beliebte Tracks</h3>
          </div>
          {[
            { title: 'Summer Vibes', artist: 'DJ Wave', plays: '2,3k' },
            { title: 'Night Drive', artist: 'Luna Beat', plays: '1,8k' }
          ].map((track) => (
            <div key={track.title} className="py-2">
              <p className="font-medium hover:text-accent-primary cursor-pointer">
                {track.title}
              </p>
              <p className="text-sm text-text-tertiary">
                {track.artist} • {track.plays} Wiedergaben
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}